import { useState } from "react";
import { ModelAccessPolicy } from "../ModelAccessPolicy";
import useCurrentUser from "../../account/hooks/useCurrentUser";
import useToast from "../../shared/hook/useToast";
import { ReprocessReason } from "../model";
import ModelService from "../services/ModelService";
import { ModelStatus } from "../../../models/Model";

const useModelReprocess = () => {
  const userCtx = useCurrentUser();
  const toast = useToast();

  const [isReprocessing, setIsReprocessing] = useState(false);

  const reprocess = async (
    model: { id: string; status: ModelStatus },
    reason: ReprocessReason,
    comment?: string
  ) => {
    if (!ModelAccessPolicy.canReprocess(userCtx.user, model)) {
      toast.error("You are not allowed to reprocess this model");
      return;
    }

    setIsReprocessing(true);
    await ModelService.reprocessModel(model.id, reason, comment);
    setIsReprocessing(false);
    toast.success("Model added to reprocessing queue");
  };

  return {
    isReprocessing,
    reprocess,
  };
};

export default useModelReprocess;
